export enum ENotificationRelatedObjectType {
  Video = 1,
  LiveStream = 2,
  Blog = 3,
  Comment = 4,
  Document = 5,
  CommunityPost = 6,
}
